"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _clsx = _interopRequireDefault(require("clsx"));
var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));
var _Button = _interopRequireDefault(require("@material-ui/core/Button"));
var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));
var _ReactSVGIcon = _interopRequireDefault(require("@micado-digital/react-svg-icon/ReactSVGIcon"));
var _filterContext = _interopRequireDefault(require("@micado-digital/react-filter/context/filterContext"));
var _useLocals = _interopRequireDefault(require("@micado-digital/react-ui/hooks/useLocals"));
var _Local = _interopRequireDefault(require("@micado-digital/react-ui/components/Local"));
var _de = _interopRequireDefault(require("../../../locals/de.json"));
var _en = _interopRequireDefault(require("../../../locals/en.json"));
var _it = _interopRequireDefault(require("../../../locals/it.json"));
var _SelectedFilter = _interopRequireDefault(require("./SelectedFilter.styles"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const SelectedFilter = _ref => {
  let {
    lang,
    onClearFilter,
    onSubmit
  } = _ref;
  const {
    defaultFilter,
    selectedFilter,
    onChange
  } = (0, _react.useContext)(_filterContext.default);
  const css = (0, _SelectedFilter.default)();
  const l = (0, _useLocals.default)({
    lang: lang,
    res: {
      de: _de.default,
      en: _en.default,
      it: _it.default
    }
  });
  const values = (0, _react.useMemo)(() => {
    const _values = [];
    for (const key of selectedFilter) {
      const filterOption = defaultFilter === null || defaultFilter === void 0 ? void 0 : defaultFilter[key];
      const {
        items = []
      } = filterOption || {};
      const selectedValues = items === null || items === void 0 ? void 0 : items.filter(item => item === null || item === void 0 ? void 0 : item.selected);
      for (const value of selectedValues) {
        const {
          id,
          title
        } = value;
        _values.push({
          identifier: key,
          id,
          title
        });
      }
    }
    return _values;
  }, [defaultFilter, selectedFilter]);
  const handleClick = (identifier, value) => {
    onChange(identifier, value);
    if (onSubmit) onSubmit();
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, !(0, _isEmpty.default)(values) && /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(css.selectedFilter, "mco-shop-product-overview-selected-filter")
  }, values === null || values === void 0 ? void 0 : values.map((value, index) => {
    const {
      id,
      identifier,
      title
    } = value;
    return /*#__PURE__*/_react.default.createElement(_Button.default, {
      className: (0, _clsx.default)(css.valueButton, "mco-shop-product-overview-selected-filter__value-button"),
      key: index,
      size: "small",
      onClick: () => handleClick(identifier, id)
    }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
      className: css.label
    }, title), /*#__PURE__*/_react.default.createElement(_ReactSVGIcon.default, {
      className: css.icon,
      src: "/img/icons/close.svg",
      size: 14
    }));
  }), /*#__PURE__*/_react.default.createElement(_Button.default, {
    className: (0, _clsx.default)(css.clearButton, "mco-shop-product-overview-selected-filter__clear-button"),
    color: "primary",
    size: "small",
    onClick: onClearFilter
  }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
    className: css.label
  }, /*#__PURE__*/_react.default.createElement(_Local.default, {
    identifier: "reactShop.productOverview.buttons.clearFilter",
    l: l
  })))));
};
var _default = exports.default = SelectedFilter;